module.exports = new __parcel__URL__("Charlie_Text-Semibold.81e35e50.woff2").toString();